import { useMutation } from "@tanstack/react-query";
import { useOktaAuth } from "@okta/okta-react";
import axiosInstance from "../../../api";
import ClassifySupportingDocumentsPayload from "../../../models/API/requestModels/classifySupportingDocumentsPayload.model";
import ClassifySupportingDocumentsResponse from "../../../models/API/responseModels/classifySupportingDocumentsResponse.model";
import toastMessages from "../../helpers/toastMessage";

const CLASSIFY_SUPPORTING_DOCUMENTS_ENDPOINT =
  "/v1/orders/new-flow/classify-supporting-documents";

function useClassifySupportingDocuments() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["classifySupportingDocuments"],
    mutationFn: async (
      payload: ClassifySupportingDocumentsPayload
    ): Promise<ClassifySupportingDocumentsResponse> => {
      const res = await axiosInstance.post<ClassifySupportingDocumentsResponse>(
        CLASSIFY_SUPPORTING_DOCUMENTS_ENDPOINT,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );

      return res.data;
    },
    retry: false,
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ??
        error?.message ??
        "Failed to classify documents";
      toastMessages.error(errorMessage);
    },
  });
}

export default useClassifySupportingDocuments;
